var React = require('react');

function Drupal (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M12.52 5.408C11.393 4.282 10.32 3.21 10 2c-.32 1.21-1.394 2.282-2.52 3.408-1.688 1.687-3.602 3.6-3.602 6.468a6.122 6.122 0 1 0 12.244 0c0-2.868-1.914-4.78-3.603-6.468Zm-6.04 7.894c-.376-.013-1.761-2.4.81-4.943l1.7 1.858a.146.146 0 0 1 .027.17.145.145 0 0 1-.038.047c-.406.416-2.136 2.15-2.351 2.75-.044.124-.11.12-.148.118ZM10 16.45a2.106 2.106 0 0 1-2.106-2.106c.008-.51.194-1.002.525-1.391.38-.464 1.58-1.77 1.58-1.77s1.183 1.325 1.579 1.766c.344.382.532.88.528 1.395A2.106 2.106 0 0 1 10 16.45Zm4.03-3.415c-.045.1-.148.265-.287.27-.248.009-.274-.118-.457-.389-.402-.595-3.91-4.26-4.566-4.97-.577-.623-.08-1.063.149-1.293L10 5.523s2.512 2.382 3.558 4.01c1.046 1.628.686 3.037.473 3.502Z"}));
}

Drupal.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"#009CDE"};

module.exports = Drupal;

Drupal.default = Drupal;
